import React, { useState } from "react";
import style from "./CustomForm.module.css";
import EjectIcon from "@mui/icons-material/ArrowForwardIos";
import ErrorIcon from "@mui/icons-material/Error";
import { memo } from "react";
import { disableNumbersOfTxtField } from "../../../Utils/disableNumbersOfTxtField";


function CustomForm(props) {
  const [showErr, setShowErr] = useState(false);
  const emailRegX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const panRegX =
    /([A-Z || a-z]){3}([P || C || p || c]){1}([A-Z || a-z]){1}([0-9]){4}([A-Z || a-z]){1}$/;

    const onChangeTextLimitFunc = (e) => {
      let val = e.target.value;

      //can enter only max digits
      if (val.length <= props.data.shouldLength) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return { ...obj, value: val };
            }
            return obj;
          })
        );
        //is something entered or not
        if (val.length > 0) {
          props.setFormData((elm) =>
            elm.map((obj, ind) => {
              if (props.ind === ind) {
                return { ...obj, isValid: true, error: "" };
              }
              return obj;
            })
          );
  
          //length limit
  
    
  
          if (props.data.minLength) {
            if (val.length < props.data.minLength || val.length > props.data.shouldLength  ) {
            props.setFormData((elm) =>
              elm.map((obj, ind) => {
                if (props.ind === ind) {
                  return {
                    ...obj,
                    isValid: false,
                    error: `${props.data.label} Should be greater than ${props.data.minLength} and less than ${props.data.shouldLength} digits!`,
                  };
                }
                return obj;
              })
            );
            }}
  
          //if number shouldn't be equal to shouldLength
         else if (val.length !== props.data.shouldLength) {
            props.setFormData((elm) =>
              elm.map((obj, ind) => {
                if (props.ind === ind) {
                  return {
                    ...obj,
                    isValid: false,
                    error: `${props.data.label} Should be ${props.data.shouldLength} digits!`,
                  };
                }
                return obj;
              })
            );
          }
        }
        else{
  
          if(props.data.required){
               props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return {
              ...obj,
              isValid: false,
              error: ``,
            };
          }
          return obj;
        })
      );
          }else{
            props.setFormData((elm) =>
            elm.map((obj, ind) => {
              if (props.ind === ind) {
                return {
                  ...obj,
                  isValid: true,
                  error: ``,
                };
              }
              return obj;
            })
          );
          }
       
        }
        
      }
  
      if(props.data.onChangeFunc){
        
        props.data.onChangeFunc(e);
      }
    };

  const onChangeTextFunc = (e) => {
    let val = e.target.value;

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, value: val };
        }
        return obj;
      })
    );

    if (val.length > 0) {
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, isValid: true, error: "" };
          }
          return obj;
        })
      );
    }else{
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, isValid: false, error: "" };
          }
          return obj;
        })
      );
    }
  };

  const onChangeNumFunc = (e) => {

    let val = e.target.value;

    //can enter only max digits
    if (val.length <= props.data.shouldLength) {
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, value: val };
          }
          return obj;
        })
      );
      //is something entered or not
      if (val.length > 0) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return { ...obj, isValid: true, error: "" };
            }
            return obj;
          })
        );

        //length limit
        if (props.data.minLength) {
          if (val.length < props.data.minLength || val.length > props.data.shouldLength  ) {
          props.setFormData((elm) =>
            elm.map((obj, ind) => {
              if (props.ind === ind) {
                return {
                  ...obj,
                  isValid: false,
                  error: `${props.data.label} Should be greater than ${props.data.minLength} and less than ${props.data.shouldLength} digits!`,
                };
              }
              return obj;
            })
          );
          }}

        //if number shouldn't be equal to shouldLength
       else if (val.length !== props.data.shouldLength) {
          props.setFormData((elm) =>
            elm.map((obj, ind) => {
              if (props.ind === ind) {
                return {
                  ...obj,
                  isValid: false,
                  error: `${props.data.label} Should be ${props.data.shouldLength} digits!`,
                };
              }
              return obj;
            })
          );
        }
      }
      else{
        props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return {
            ...obj,
            isValid: false,
            error: ``,
          };
        }
        return obj;
      })
    );
      }
      
    }

    if(props.data.onChangeFunc){
      
      props.data.onChangeFunc(e);
    }
  };

  const onChangeEmailFunc = (e) => {
    let val = e.target.value;

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, value: val };
        }
        return obj;
      })
    );

    if (val.length > 0) {
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, isValid: true, error: "" };
          }
          return obj;
        })
      );

      if (!emailRegX.test(val)) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return {
                ...obj,
                isValid: false,
                error: `Please enter a valid ${props.data.label}!`,
              };
            }
            return obj;
          })
        );
      }
    } else{
      props.setFormData((elm) =>
    elm.map((obj, ind) => {
      if (props.ind === ind) {
        return {
          ...obj,
          isValid: false,
          error: ``,
        };
      }
      return obj;
    })
  );
    }
  };

  const onChangePanFunc = (e) => {
    let val = e.target.value;

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, value: val };
        }
        return obj;
      })
    );

    if (val.length > 0) {
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, isValid: true, error: "" };
          }
          return obj;
        })
      );

      if (!panRegX.test(val)) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return {
                ...obj,
                isValid: false,
                error: `Please enter a valid ${props.data.label}!`,
              };
            }
            return obj;
          })
        );
      }
    } else{
      props.setFormData((elm) =>
    elm.map((obj, ind) => {
      if (props.ind === ind) {
        return {
          ...obj,
          isValid: false,
          error: ``,
        };
      }
      return obj;
    })
  );
    }
  };

  const onChangeAmountFunc = (e) => {
    let val = e.target.value;
    e.target.value =
      val.indexOf(".") >= 0
        ? val.substr(0, val.indexOf(".")) + val.substr(val.indexOf("."), 3)
        : val;

        //max length limit 
        if(props.data.max){
          if(val.length > props.data.max.toString().length){
            return
          }
        }
        

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, value: val };
        }
        return obj;
      })
    );

    // is something entered or not
    if (val.length > 0) {
      props.setFormData((elm) =>
        elm.map((obj, ind) => {
          if (props.ind === ind) {
            return { ...obj, isValid: true, error: "" };
          }
          return obj;
        })
      );

      if (val < props.data.min) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return {
                ...obj,
                isValid: false,
                error: `${props.data.label} Should be greater than ₹${props.data.min}!`,
              };
            }
            return obj;
          })
        );
      }
      if (val > props.data.max) {
        props.setFormData((elm) =>
          elm.map((obj, ind) => {
            if (props.ind === ind) {
              return {
                ...obj,
                isValid: false,
                error: `${props.data.label} Should be less than ₹${props.data.max}!`,
              };
            }
            return obj;
          })
        );
      }
    } else{
      props.setFormData((elm) =>
    elm.map((obj, ind) => {
      if (props.ind === ind) {
        return {
          ...obj,
          isValid: false,
          error: ``,
        };
      }
      return obj;
    })
  );
    }
  };

  const onFocusFunc = (e) => {
    setShowErr(false);
  };

  const onBlurFunc = (e) => {
    setShowErr(true);
  };

  const onChangeCheckbox = (e) => {
    let val = e.target.checked;

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, value: val };
        }
        return obj;
      })
    );

    props.setFormData((elm) =>
      elm.map((obj, ind) => {
        if (props.ind === ind) {
          return { ...obj, isValid: true, error: "" };
        }
        return obj;
      })
    );
  };

  return (
    <>
     {props.data.type === "textWithLimit" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type={"text"}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeTextLimitFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />

              {props.data.error}
            </p>
          </p>
        </div>
      )}

{props.data.type === "password" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type="password"
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeNumFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
            onWheel={(e) => e.target.blur()}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "text" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type={"text"}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeTextFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            onKeyDown={props.data.isAlphaNumeric?()=>{}:disableNumbersOfTxtField}
            className={`${showErr && props.data.error && style.inputError} ${style.text_transform}`}
            disabled={props.data.disabled && props.data.disabled}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />

              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "number" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type="number" onKeyUp={()=>window.upDownDisabled()}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeNumFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
            onWheel={(e) => e.target.blur()}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "amount" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type="number" onKeyUp={()=>window.upDownDisabled()}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeAmountFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
            onWheel={(e) => e.target.blur()}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "email" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type={"text"}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangeEmailFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "pan" && (
        <div className={style.inputLabel}>
            {
            props.data.hideLable !== "yes" &&  <p>{props.data.label}</p>
          }
         
          <input
            required={props.data.required}
            type={"text"}
            name={props.data.name}
            value={props.data.value}
            placeholder={props.data.placeholder}
            onChange={onChangePanFunc}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            className={`${showErr && props.data.error && style.inputError}`}
            disabled={props.data.disabled && props.data.disabled}
            style={{ textTransform: "uppercase" }}
          />
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}

      {props.data.type === "checkbox" && (
        <div className={style.inputCheckbox}>
          <div>
            <input
              required={props.data.required}
              type={"checkbox"}
              name={props.data.name}
              value={props.data.value}
              onChange={onChangeCheckbox}
              onFocus={onFocusFunc}
              onBlur={onBlurFunc}
              className={`${showErr && props.data.error && style.inputError}`}
              disabled={props.data.disabled && props.data.disabled}
            />
            <p>{props.data.label}</p>
          </div>
          <p
            className={`${style.error} ${
              showErr && props.data.error ? style.showError : style.hideError
            }`}
          >
            <p>
              <EjectIcon />
              <ErrorIcon />
              {props.data.error}
            </p>
          </p>
        </div>
      )}
    </>
  );
}

export default memo(CustomForm);
